import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/app/(main)/(content)/articles/[slug]/error.tsx");
